import React, { type ComponentProps } from 'react';
import { StyleSheet } from 'react-native';

import { theme } from '@garnish/constants';

import { AspectRatioImage, getCloudinaryUrl } from '../../../Image';

// ─────────────────────────────────────────────────────────────────────────────

export const IngredientCardImage = (props: IngredientCardImageProps) => {
  const {
    style,
    source,
    imageWidth = 230,
    aspectRatioY = 23,
    aspectRatioX = 26,
    ...restProps
  } = props;

  const formattedSource = getCloudinaryUrl(source as string, {
    crop: 'scale',
    width: imageWidth,
  });

  return (
    <AspectRatioImage
      aspectRatioY={aspectRatioY}
      aspectRatioX={aspectRatioX}
      source={formattedSource}
      style={[styles.image, style]}
      pointerEvents="none" // NOTE: This is to prevent the image from being selected/dragged.
      {...restProps}
    />
  );
};

// ─── Styles ──────────────────────────────────────────────────────────────────

const styles = StyleSheet.create({
  image: {
    overflow: 'hidden',
    borderRadius: theme.radius.large,
    userSelect: 'none',
  },
});

// ─── Types ───────────────────────────────────────────────────────────────────

type IngredientCardImageProps = {
  source: string;
  imageWidth?: number;
  aspectRatioX?: number;
  aspectRatioY?: number;
} & Omit<ComponentProps<typeof AspectRatioImage>, 'aspectRatioX' | 'aspectRatioY'>;
